"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWidgetWrapper = exports.LabelOrDivWrapper = exports.LabelOrDiv = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const SurveyErrorMessage_1 = __importDefault(require("./SurveyErrorMessage"));
const HelpPopupLink_1 = __importDefault(require("./HelpPopupLink"));
const FieldsetWrapper = (props) => {
    var _a;
    const [isCollapsed, setIsCollapsed] = react_1.default.useState(props.isCollapsed);
    return (react_1.default.createElement("fieldset", null,
        react_1.default.createElement("div", { className: props.className },
            react_1.default.createElement("legend", null,
                react_1.default.createElement("div", { className: "apptr__form__label-standalone", onClick: props.widgetConfig.canBeCollapsed === true
                        ? () => setIsCollapsed(!isCollapsed)
                        : undefined }, props.widgetConfig.containsHtml ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.label } })) : (react_1.default.createElement("div", { className: "label" },
                    react_1.default.createElement(react_markdown_1.default, null, props.label)))),
                props.errorMessage !== undefined && (react_1.default.createElement(SurveyErrorMessage_1.default, { containsHtml: props.widgetConfig.containsHtml === true, text: props.errorMessage })),
                props.helpTitle && typeof props.helpContent === 'function' && (react_1.default.createElement(HelpPopupLink_1.default, { containsHtml: ((_a = props.widgetConfig.helpPopup) === null || _a === void 0 ? void 0 : _a.containsHtml) === true, title: props.helpTitle, content: props.helpContent })))),
        !isCollapsed && props.children));
};
const LabelOrDiv = (props) => props.needsLabel ? (react_1.default.createElement("label", { htmlFor: props.widgetId, onClick: props.onClick }, props.children)) : (react_1.default.createElement("div", { className: "apptr__form__label-standalone", id: `${props.widgetId}_label`, onClick: props.onClick }, props.children));
exports.LabelOrDiv = LabelOrDiv;
const LabelOrDivWrapper = (props) => {
    var _a;
    const [isCollapsed, setIsCollapsed] = react_1.default.useState(props.isCollapsed);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: props.className },
            react_1.default.createElement(exports.LabelOrDiv, { widgetId: props.widgetId, needsLabel: props.needsLabel, onClick: props.widgetConfig.canBeCollapsed === true
                    ? () => setIsCollapsed(!isCollapsed)
                    : undefined }, props.widgetConfig.containsHtml ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.label } })) : (react_1.default.createElement("div", { className: "label" },
                react_1.default.createElement(react_markdown_1.default, null, props.label)))),
            props.errorMessage !== undefined && (react_1.default.createElement(SurveyErrorMessage_1.default, { containsHtml: props.widgetConfig.containsHtml === true, text: props.errorMessage })),
            props.helpTitle && typeof props.helpContent === 'function' && (react_1.default.createElement(HelpPopupLink_1.default, { containsHtml: ((_a = props.widgetConfig.helpPopup) === null || _a === void 0 ? void 0 : _a.containsHtml) === true, title: props.helpTitle, content: props.helpContent }))),
        !isCollapsed && props.children));
};
exports.LabelOrDivWrapper = LabelOrDivWrapper;
const InputWidgetWrapper = (props) => {
    const typeOfWrapping = react_1.default.useMemo(() => props.widgetConfig.inputType === 'radio' ||
        props.widgetConfig.inputType === 'checkbox' ||
        props.widgetConfig.inputType === 'radioNumber'
        ? 'fieldset'
        : props.widgetConfig.inputType === 'slider' || props.widgetConfig.inputType === 'multiselect'
            ? 'noLabel'
            : 'label', []);
    return typeOfWrapping === 'fieldset' ? (react_1.default.createElement(FieldsetWrapper, Object.assign({}, props))) : (react_1.default.createElement(exports.LabelOrDivWrapper, Object.assign({}, props, { needsLabel: typeOfWrapping === 'label' })));
};
exports.InputWidgetWrapper = InputWidgetWrapper;
exports.default = exports.InputWidgetWrapper;
//# sourceMappingURL=InputWidgetWrapper.js.map